import { render, staticRenderFns } from "./CreateOrganizationPanel.vue?vue&type=template&id=6f2e9547&scoped=true&"
import script from "./CreateOrganizationPanel.vue?vue&type=script&lang=js&"
export * from "./CreateOrganizationPanel.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrganizationPanel.vue?vue&type=style&index=0&id=6f2e9547&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2e9547",
  null
  
)

export default component.exports